// src/components/Breadcrumb.tsx
// The portal header trail. Database ids are left out, curriculum keys read
// as "Week 3" / "Lesson 2", and every step but the last is a link.

import { Link, useLocation } from "react-router-dom";

const ID = /^[0-9a-f]{24}$/i;
const WEEK = /^(fb|ex|inv)-(q|s)\d+-w(\d+)$/;
const LESSON = /^(fb|ex|inv)-(q|s)\d+-w\d+-m(\d+)$/;

function labelFor(seg: string, labels: Record<string, string>) {
  if (labels[seg]) return labels[seg];
  const lesson = seg.match(LESSON);
  if (lesson) return `Lesson ${Number(lesson[3])}`;
  const week = seg.match(WEEK);
  if (week) return `Week ${Number(week[3])}`;
  const words = seg.replace(/-/g, " ");
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export default function Breadcrumb({ labels, root }: { labels: Record<string, string>; root: string }) {
  const { pathname } = useLocation();
  const parts = pathname.split("/").filter(Boolean);
  const crumbs = parts
    .map((seg, i) => ({ seg, to: "/" + parts.slice(0, i + 1).join("/") }))
    .filter((c) => !ID.test(c.seg));

  return (
    <nav aria-label="Breadcrumb" className="flex min-w-0 items-center gap-1.5 truncate text-xs text-[#8189a0]">
      {crumbs.map((c, i) => {
        const isLast = i === crumbs.length - 1;
        const label = labelFor(c.seg, labels);
        const linkable = !isLast && c.to !== `/${root}`;
        return (
          <span key={c.to} className="flex items-center gap-1.5">
            {i > 0 && <span className="opacity-40">/</span>}
            {isLast ? (
              <span className="font-semibold text-[#16213e]">{label}</span>
            ) : linkable ? (
              <Link to={c.to} className="transition-colors hover:text-[#16213e]">
                {label}
              </Link>
            ) : (
              <span>{label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
